<template>
  <div class="pdf-report-medicine-stock">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal
        id="filter"
        size="xl"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
        @shown="handleModalShown"
      >
        <div class="container row">
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center pt-0 pb-0"
          >
            <label>QUAL MEDICAMENTO</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="special_control"
                  @change="handleChangeMedicineType"
                  id="special_control"
                />
                <label class="form-check-label" for="special_control">
                  CONTROLE ESPECIAL
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="common_use"
                  @change="handleChangeMedicineType"
                  id="common_use"
                />
                <label class="form-check-label" for="common_use">
                  USO COMUM
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <label>MÊS E ANO</label>
            <input
              :disabled="loading"
              type="month"
              v-model="month"
              :max="maxMonth"
              min="2022-02"
              class="form-control"
            />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="medicine_resident"
                  id="medicine_resident"
                />
                <label class="form-check-label" for="medicine_resident">
                  RESIDENTE
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="medicine_rest_home"
                  id="medicine_rest_home"
                />
                <label class="form-check-label" for="medicine_rest_home">
                  EMPRESA
                </label>
              </div>
            </div>
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean mt-2"
          >
            <b-overlay :show="loadingFilterMedicines" opacity="0.99">
              <div>
                <label>PESQUISAR MEDICAMENTO (OPCIONAL)</label>
                <input
                  :disabled="loading"
                  v-model="filter"
                  type="text"
                  class="form-control"
                  placeholder="Digite para buscar"
                  @input="handleFilterMedicines"
                />
                <b-form-group
                  class="mt-2"
                  style="height: 200px; overflow-y: scroll"
                >
                  <b-form-radio
                    v-model="medicine_id"
                    value=""
                    name="medicine"
                    :disabled="loading"
                  >
                    <strong>TODOS OS MEDICAMENTOS</strong>
                  </b-form-radio>
                  <b-form-radio
                    v-for="medicine in medicines"
                    :key="medicine.id"
                    :value="medicine.id"
                    v-model="medicine_id"
                    name="medicine"
                    :disabled="loading"
                  >
                    {{ String(medicine.name).toUpperCase() }}
                  </b-form-radio>
                  <div
                    v-if="medicines.length == 0 && hasMedicineType"
                    class="text-center p-2"
                  >
                    NENHUM MEDICAMENTO ENCONTRADO
                  </div>
                  <div v-if="!hasMedicineType" class="text-center p-2">
                    MARQUE CONTROLE ESPECIAL OU USO COMUM PARA LISTAR
                  </div>
                </b-form-group>
              </div>
            </b-overlay>
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row content-filter">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: MEDICAMENTOS - PORTARIA 344/1998 - FILTRO POR MEDICAMENTO
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="dates.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="dates.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            FILTRANDO:
            <span
              ><strong>{{ ownerLabel }}</strong> |
            </span>
            <span
              ><strong>{{ selectedMedicineLabel }}</strong> |
            </span>
            <span
              ><strong>MÊS: {{ formatDateToMonthYear(appliedMonth) }}</strong>
            </span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="dates.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <table v-if="dates.length > 0">
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div class="row">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex flex-column align-items-center justify-content-center"
                    >
                      <h5 class="m-0">{{ reportTitle }}</h5>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">
                  <div
                    v-for="item in dates"
                    :key="item.id"
                    class="border-bottom"
                  >
                    <div
                      class="d-flex flex-column justify-content-center align-items-center"
                    >
                      <h5 class="m-0" v-if="item.medicine_name">
                        {{ item.medicine_name }}
                      </h5>
                      <h6 class="m-0" v-if="item.active_ingredient">
                        {{ item.active_ingredient }}
                      </h6>
                    </div>
                    <div
                      v-if="!item.dates || item.dates.length == 0"
                      class="text-center"
                    >
                      Sem movimentações!
                    </div>
                    <template v-else>
                      <div class="row">
                        <div class="text-center pt-0 pb-0 col-md-7"></div>
                        <div class="text-center pt-0 pb-0 col-md-1">
                          <span>Entrada</span>
                        </div>
                        <div class="text-center pt-0 pb-0 col-md-1">
                          <span>Saída</span>
                        </div>
                        <div class="text-center pt-0 pb-0 col-md-1">
                          <span>Perda</span>
                        </div>
                        <div class="text-center pt-0 pb-0 col-md-2">
                          <span>Estoque total</span>
                        </div>
                      </div>
                      <div class="row opening-balance">
                        <div class="pt-0 pb-0 col-md-10">
                          <small>Saldo anterior</small>
                        </div>
                        <div class="text-center pt-0 pb-0 col-md-2">
                          <small
                            >{{ item.opening_balance || 0 }}
                            {{ item.unit_of_measurement_abbreviation }}</small
                          >
                        </div>
                      </div>
                      <div
                        v-for="date in item.dates"
                        :key="`${item.id}-${date.date}`"
                        class="content-movimentation"
                      >
                        <Medicine
                          :date="date"
                          :report_type="report_type"
                          :medicine_name="item.medicine_name"
                          :active_ingredient="item.active_ingredient"
                          :unit_of_measurement_abbreviation="
                            item.unit_of_measurement_abbreviation
                          "
                        />
                      </div>
                    </template>
                  </div>
                </div>
                <div class="footer text-center">
                  <hr class="mb-1 border-black" />
                  <h6 class="mb-0 worksansr">
                    (Assinatura eletrônica)
                    <strong>
                      {{
                        professionalClassCouncilValue({
                          id: user.professional_class_council_id,
                          name: user.name,
                          profile: user.profile_name,
                          cpf: user.cpf,
                          office: user.office,
                          value: user.professional_class_council_value,
                        })
                      }}
                      <span class="ml-1"> - {{ generatedAt }} </span>
                    </strong>
                  </h6>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import routes from "../../routes";

import Medicine from "./MedicineStock/Medicine";

import {
  formatDateToMonthYear,
  professionalClassCouncilValue,
} from "../../lib/format";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import NavBar from "../NavBar";

import { userData } from "../../lib/functions";

import moment from "moment";

// Único tipo suportado neste relatório
const REPORT_TYPE = "analytical";
const SEARCH_DEBOUNCE_MS = 400;

export default {
  name: "ReportsMedicineStock",
  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
    Medicine,
  },
  data() {
    return {
      report_type: REPORT_TYPE,
      special_control: false,
      common_use: false,
      medicine_resident: false,
      medicine_rest_home: false,
      month: moment().format("YYYY-MM"),
      medicine_id: "",
      filter: "",
      medicines: [],
      dates: [],
      // Filtros usados na última busca (o cabeçalho não muda se o usuário mexer no modal sem filtrar)
      applied: {},
      appliedMonth: "",
      generatedAt: "",
      user: {},
      rest_home_name: "",
      rest_home_logo_url: null,
      logo: null,
      loadingFilterMedicines: false,
      loading: false,
      errors: [],
      searchTimer: null,
    };
  },
  computed: {
    maxMonth() {
      return moment().format("YYYY-MM");
    },
    hasMedicineType() {
      return this.special_control || this.common_use;
    },
    reportTitle() {
      const { special_control, common_use } = this.applied;
      if (special_control && common_use)
        return "CONTROLE DE MEDICAMENTOS - CONTROLE ESPECIAL E USO COMUM";
      if (special_control)
        return "CONTROLE DE MEDICAMENTOS - CONTROLE ESPECIAL";
      return "CONTROLE DE MEDICAMENTOS - USO COMUM";
    },
    ownerLabel() {
      const { medicine_resident, medicine_rest_home } = this.applied;
      if (medicine_resident && medicine_rest_home) return "RESIDENTE E EMPRESA";
      if (medicine_resident) return "RESIDENTE";
      return "EMPRESA";
    },
    selectedMedicineLabel() {
      return this.applied.medicine_name || "TODOS OS MEDICAMENTOS";
    },
  },
  created() {
    this.retrieve();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    formatDateToMonthYear,
    professionalClassCouncilValue,
    retrieve() {
      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      const { modal } = this.$router.currentRoute.query;
      if (modal) this.$bvModal.show("filter");
    },
    handleModalShown() {
      if (this.hasMedicineType && this.medicines.length == 0) {
        this.getMedicines();
      }
    },
    handleChangeMedicineType() {
      // O medicamento marcado pode não existir no novo tipo
      this.medicine_id = "";
      this.getMedicines();
    },
    handleFilterMedicines() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.getMedicines, SEARCH_DEBOUNCE_MS);
    },
    async getMedicines() {
      if (!this.hasMedicineType) {
        this.medicines = [];
        return;
      }

      this.loadingFilterMedicines = true;
      try {
        const { filter, special_control, common_use } = this;

        const response = await api.get(
          "/rest-home/medicines-in-stock-by-residents-new-stock",
          { params: { filter, special_control, common_use } }
        );

        const { error, errors, medicines } = response.data;

        if (error) {
          this.errors = errors;
          this.medicines = [];
        } else {
          this.errors = [];
          this.medicines = medicines || [];
        }
      } catch (error) {
        console.log(error);
        this.errors = ["Erro ao carregar medicamentos. Tente novamente."];
      } finally {
        this.loadingFilterMedicines = false;
      }
    },
    validate() {
      const errors = [];
      if (!this.hasMedicineType)
        errors.push("Informe CONTROLE ESPECIAL, USO COMUM ou AMBOS");
      if (!this.month) errors.push("Informe o mês");
      if (!this.medicine_resident && !this.medicine_rest_home)
        errors.push("Informe RESIDENTE, EMPRESA ou AMBOS");
      return errors;
    },
    async paginate() {
      const validationErrors = this.validate();
      if (validationErrors.length > 0) {
        this.errors = validationErrors;
        return;
      }

      this.loading = true;
      try {
        const {
          medicine_id,
          special_control,
          common_use,
          month,
          medicine_resident,
          medicine_rest_home,
        } = this;

        const params = {
          special_control,
          common_use,
          report_type: REPORT_TYPE,
          month,
          medicine_resident,
          medicine_rest_home,
        };

        // Só envia medicine_id quando um medicamento foi escolhido
        if (medicine_id) params.medicine_id = medicine_id;

        const response = await api.get(
          "/rest-home/report/medicine-stock/filter",
          { params }
        );

        const { residents, error, errors } = response.data;

        if (error) {
          this.dates = [];
          this.errors = errors;
          return;
        }

        const selected = this.medicines.find(({ id }) => id == medicine_id);

        this.errors = [];
        this.dates = residents || [];
        this.applied = {
          special_control,
          common_use,
          medicine_resident,
          medicine_rest_home,
          medicine_name: selected ? String(selected.name).toUpperCase() : "",
        };
        this.appliedMonth = month;
        this.generatedAt = moment().format("DD/MM/YYYY HH:mm:ss");
        this.$bvModal.hide("filter");
      } catch (error) {
        console.log(error);
        this.errors = ["Erro ao gerar o relatório. Tente novamente."];
      } finally {
        this.loading = false;
      }
    },
    handleToPrint: () => window.print(),
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.pdf-report-medicine-stock .text-amount {
  font-size: 13px;
}

.pdf-report-medicine-stock .date-amount {
  font-size: 13px;
}

.pdf-report-medicine-stock .opening-balance small {
  font-size: 12px;
  font-style: italic;
}

.pdf-report-medicine-stock .header,
.pdf-report-medicine-stock .header-space {
  height: 120px;
}

.pdf-report-medicine-stock .footer,
.pdf-report-medicine-stock .footer-space {
  height: 50px;
}

.pdf-report-medicine-stock .header {
  position: fixed;
  top: 0;
}

.pdf-report-medicine-stock .logo {
  height: 50px;
  object-fit: contain;
}

.pdf-report-medicine-stock .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-medicine-stock table,
.pdf-report-medicine-stock td,
.pdf-report-medicine-stock th {
  width: 100% !important;
  cursor: auto !important;
}

.pdf-report-medicine-stock th {
  background-color: #f5f5f5;
}

.pdf-report-medicine-stock .medicine-name {
  font-size: 14px;
}

.pdf-report-medicine-stock small {
  font-size: 12px;
}

@media print {
  .pdf-report-medicine-stock table {
    width: 100% !important;
    border: none !important;
  }

  .pdf-report-medicine-stock .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .pdf-report-medicine-stock .content {
    page-break-inside: avoid !important;
  }

  .pdf-report-medicine-stock .content-movimentation {
    page-break-inside: avoid !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  .pdf-report-medicine-stock table {
    page-break-before: always !important;
  }

  .pdf-report-medicine-stock .header,
  .pdf-report-medicine-stock .header-space {
    height: 120px;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-medicine-stock button {
    display: none;
  }

  .pdf-report-medicine-stock .nav--bar {
    display: none !important;
  }

  .pdf-report-medicine-stock .auth--by--session--expired {
    display: none !important;
  }

  .pdf-report-medicine-stock .content-filter {
    display: none;
  }
}
</style>